/**
 * Canonical form-engine modes (model.json `modes.*`, rules `meta.mode` gates).
 *
 * Compose/modal layers historically used `'add'` (legacy Formik `modalStatus === 'Add'`).
 * New code MUST use `'create'`. `'add'` is accepted only at boundaries via normalizeFormEngineMode().
 */

export const FORM_ENGINE_MODES = ['create', 'edit', 'view'] as const;
export type FormEngineMode = (typeof FORM_ENGINE_MODES)[number];

/** @deprecated Use `'create'`. Legacy compose/modal alias only. */
export const LEGACY_CREATE_MODE_ALIAS = 'add' as const;

export function normalizeFormEngineMode(mode: unknown): FormEngineMode | undefined {
  if (mode === 'create' || mode === 'edit' || mode === 'view') {
    return mode;
  }
  if (mode === LEGACY_CREATE_MODE_ALIAS) {
    return 'create';
  }
  return undefined;
}

export function isCreateFormMode(mode: unknown): boolean {
  return normalizeFormEngineMode(mode) === 'create';
}

/** Entity title prefix for compose modals — UI says "Add", engine mode is `create`. */
export function formModeEntityLabel(mode: unknown): string {
  const normalized = normalizeFormEngineMode(mode);
  switch (normalized) {
    case 'create':
      return 'Add';
    case 'edit':
      return 'Edit';
    case 'view':
      return 'View';
    default:
      if (typeof mode === 'string' && mode.length > 0) {
        return mode.charAt(0).toUpperCase() + mode.slice(1);
      }
      return '';
  }
}
